import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../utils/api';
import { getApiErrorMessage } from '../utils/errorMessage';
import './Auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    if (!email) {
      setError('Please enter your email address.');
      setLoading(false);
      return;
    }

    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError('Please enter a valid email address.');
      setLoading(false);
      return;
    }

    try {
      const response = await api.post('/auth/forgot-password', {
        email: email.toLowerCase()
      });

      if (response.data.success) {
        setSuccess('If that email exists, a password reset link has been sent. Please check your email.');
        setEmail(''); // Clear email for security
      } else {
        setError(response.data.message || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Forgot password error:', error);
      const errorMessage = getApiErrorMessage(error, 'Something went wrong. Please try again.');
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <h2>Forgot Password</h2>
          <p style={{ textAlign: 'center', color: '#666', marginBottom: '30px', fontSize: '14px' }}>
            Enter your email address and we'll send you a link to reset your password.
          </p>
          
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                required
                disabled={loading || success}
              />
            </div>

            {error && <div className="error-message">{error}</div>}
            {success && <div className="success-message">{success}</div>}

            <button 
              type="submit" 
              className="btn btn-primary btn-block"
              disabled={loading || success}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <div style={{ marginTop: '20px', textAlign: 'center' }}>
              <p style={{ color: '#666', fontSize: '14px' }}>
                Remember your password?{' '}
                <Link 
                  to="/login"
                  style={{ color: '#2c7a7b', textDecoration: 'none', fontWeight: '600' }}
                >
                  Back to Login
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
